import api from './api'

const closureService = {
  // Get all closures
  getClosures: (params) => api.get('/mrd/closure', { params }),

  // Get closure by ID
  getClosureById: (id) => api.get(`/mrd/closure/${id}`),

  // Get closure for file
  getFileClosures: (fileId) => api.get(`/mrd/closure/file/${fileId}`),

  // Close file
  closeFile: (fileId, data) => api.post(`/mrd/closure/${fileId}`, data),

  // Reopen file
  reopenFile: (closureId, data) => api.post(`/mrd/closure/${closureId}/reopen`, data),

  // Get closure statistics
  getClosureStats: (params) => api.get('/mrd/closure/stats/summary', { params }),

  // Get closure dashboard
  getClosureDashboard: () => api.get('/mrd/closure/dashboard/data'),

  // Get TAT report
  getTATReport: (params) => api.get('/mrd/closure/tat-report', { params }),

  // Get verification checklist
  getVerificationChecklist: (fileId) => api.get(`/mrd/closure/verification-checklist/${fileId}`),

  // Update verification checklist
  updateVerificationChecklist: (fileId, data) => api.post(`/mrd/closure/${fileId}/checklist`, data),

  // Print closure sheet
  printClosureSheet: (fileId) => api.post(`/mrd/closure/${fileId}/print-closure-sheet`),

  // Get audit trail
  getAuditTrail: (closureId) => api.get(`/mrd/closure/audit/${closureId}`),

  // Lock closure
  lockClosure: (closureId) => api.post(`/mrd/closure/${closureId}/lock`),

  // Unlock closure
  unlockClosure: (closureId, data) => api.post(`/mrd/closure/${closureId}/unlock`, data),

  // Delete closure
  deleteClosure: (id) => api.delete(`/mrd/closure/${id}`)
}

export default closureService